import {onMounted, onUnmounted, ref} from "vue";
import axios from "axios";
import {layer} from "@layui/layui-vue";

const APP_VERSION = "1.3.6";
const delay = ref(undefined)

export function useUpdateService(){

    let timerId = null;

    function connect(){
        let start = Date.now();
        axios.get("/connect",{headers: {version: APP_VERSION}})
            .then(function (response) {
                if (response.data.code == 100){
                    layer.msg(response.data.msg);
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }
            })
            .catch(function () {
                console.log("网络请求失败，请稍后重试")
            })
            .finally(function () {
                // console.log("finally")
                delay.value = (Date.now() - start);
            });
    }

    onMounted(() => {
        timerId = setInterval(() => {
            connect()
        }, 60000);
    })

    onUnmounted(() => {
        clearInterval(timerId);
    })

    return {APP_VERSION, delay}
}